(function ($) {
  "use strict";

  const ITEM_ID = "10107802";
  const SHOP_BID = "203706";
  const VARIANT_ID = "555a00046";

  const BASE_IMG = "https://www.rakuten.ne.jp/gold/arne-interior/size_order/images/nook/";
  const BG_IMG = "https://www.rakuten.ne.jp/gold/arne/size_order/images/";
  const EXISTING_URL = "https://interior-arne.com/products/";

  const LIMITS = {
    haba: { min: 60, max: 180, label: "幅" },
    depth: { min: 40, max: 90, label: "奥行" },
    seat_depth: { min: 25, max: 25, label: "高さ(座面)" }
  };

  const FABRIC_BAND = {
    A: ["ns7", "sofia", "modern"],
    B: ["resort"],
    C: ["holiday", "denim", "leather", "meta", "magic", "cuera", "moq"],
    D: ["michael"],
    E: ["caleido", "barricade"]
  };

  const ROW_BASE = {
    A: 0,
    B: 6,
    C: 12,
    D: 18,
    E: 24
  };

  const FABRIC_MATERIAL_TEXT = {
    ns7: "ポリエステル48%、綿32%、アクリル20%",
    cuera: "ポリエステル100%(ペット対応・軽撥水加工)",
    sofia: "ポリエステル100%(撥水加工・ノーホルマリン加工済)",
    modern: "ポリエステル100%(撥水加工・ノーホルマリン加工済)",
    denim: "ポリエステル48%、綿32%、アクリル20%",
    resort: "ポリエステル100%",
    holiday: "ポリエステル100%",
    leather: "ポリウレタン100%(合皮)",
    meta: "PVC100%(合皮)<br>※抗菌機能付き生地使用",
    moq: "アクリル100%(モケット生地)",
    michael: "アクリル100%(モケット生地)",
    caleido: "麻37%・綿63%",
    barricade: "PVC100%(合皮)<br>※抗菌・抗ウイルス機能付き生地使用",
    magic: "PVC100%(合皮)<br>※防汚・抗菌機能付き生地使用"
  };

  const COLOR_DESC_TEXT = {
    ns7: "少し硬めのスッキリとした肌ざわり。繊維が立っていないので糸くず等が絡まりにくく汚れにくいのが特徴です。",
    cuera: "ひっかきキズにも強い、なめらかでしっとりとしたタッチ感のスエード調ファブリック。",
    sofia: "ほんのり起毛した優しい肌触り。ノーホルマリン加工でシックハウス症候群の心配がありません。撥水加工が施されています。",
    modern: "落ち着いたアースカラーのモダン生地。ほんのり起毛しており、撥水加工が施されています。",
    denim: "少し硬めでスッキリとした手触りのデニム生地。カジュアルや西海岸風など幅広いテイストに合う生地です。",
    resort: "発色の良いカラーを取り揃えたリゾート生地。かすり調で派手過ぎず、大人っぽく見せてくれます。",
    holiday: "ゆったりと過ごす大人の休日を表しているかのようなカラーリングのホリデイ生地。どんなお部屋にも馴染みます。",
    leather: "汚れてもさっと拭き取ることができ、お手入れも簡単。革のような風合いなのでオフィスや待合室にぴったり。",
    meta: "ムラ感のある上品な表情に仕上げたアンティーク調レザー。",
    moq: "肌触りが良く高級感を感じさせます。電車の座席などに使用されるしっかりとした生地です。",
    michael: "エレガントな柄が箔押しされたミカエル生地。モケットよりも更に高級感を感じさせてくれます。",
    caleido: "特殊な起毛加工により天然繊維ならではの肌触りと強度を損なわず、高い耐久性をもって使用が出来ます。",
    barricade: "防汚・抗菌機能に加え、抗ウイルス性能が備わった生地。お子様や人が沢山使う場所に最適。",
    magic: "防汚・抗菌機能が備わった生地でお子様や人が沢山使う場所に最適。"
  };

  let priceTable = null;
  let existingList = null;
  let colorOriginalSlides = null;

  function onlyDigits(v) {
    return String(v == null ? "" : v).replace(/[^\d]/g, "");
  }

  function readInt(id) {
    const el = document.getElementById(id);
    if (!el) return { el: null, val: NaN, isEmpty: true };
    const cleaned = onlyDigits(el.value);
    if (el.value !== cleaned) el.value = cleaned;
    const isEmpty = cleaned === "";
    const n = isEmpty ? NaN : parseInt(cleaned, 10);
    return { el: el, val: n, isEmpty: isEmpty };
  }

  function ceil10(n) {
    return Math.ceil(n / 10) * 10;
  }

  function formatYen(n) {
    const s = String(n == null ? "" : n).replace(/[^\d]/g, "");
    if (!s) return "";
    return s.replace(/\B(?=(\d{3})+(?!\d))/g, ",") + "円";
  }

  function getFabricType() {
    const el = document.querySelector('input[name="colortype1"]:checked');
    return (el && el.dataset && el.dataset.type ? el.dataset.type : "").toLowerCase();
  }

  function getFabricName() {
    const el = document.querySelector('input[name="colortype1"]:checked');
    return el ? el.value : "";
  }

  function getColorName() {
    const el = document.querySelector('input[name="colortype2"]:checked');
    return el ? el.value : "";
  }

  function getColorId() {
    const el = document.querySelector('input[name="colortype2"]:checked');
    return el ? el.id : "";
  }

  function getLegValue() {
    const el = document.querySelector('input[name="option"]:checked');
    return el ? el.value : "";
  }

  function getLegHeight() {
    const el = document.querySelector('input[name="option"]:checked');
    const src = String((el && (el.id || el.value)) || "");
    const m = src.match(/(\d+)/);
    const n = parseInt(m ? m[1] : "", 10);
    return Number.isNaN(n) ? NaN : n;
  }

  function getLegColorToken() {
    const el = document.querySelector('input[name="option"]:checked');
    const id = String((el && el.id) || "").toLowerCase();
    const val = String((el && el.value) || "");
    if (id.indexOf("na") !== -1 || val.indexOf("ナチュラル") !== -1) return "nt";
    return "dbr";
  }

  function getBandByFabric(type) {
    const t = String(type || "").toLowerCase();
    if (FABRIC_BAND.A.indexOf(t) !== -1) return "A";
    if (FABRIC_BAND.B.indexOf(t) !== -1) return "B";
    if (FABRIC_BAND.C.indexOf(t) !== -1) return "C";
    if (FABRIC_BAND.D.indexOf(t) !== -1) return "D";
    if (FABRIC_BAND.E.indexOf(t) !== -1) return "E";
    return null;
  }

  function $sizeMsg() {
    const node = document.querySelector(".form_size + .msg");
    return node ? $(node) : $();
  }

  function $orderMsg() {
    return $(".order-summary > .msg");
  }

  function setCheckoutUIEnabled(on) {
    const price = document.querySelector(".check_price");
    const cart = document.querySelector(".cart--btn");
    if (price) {
      price.setAttribute("style", on ? "" : "visibility: hidden");
    }
    if (cart) {
      if (on) cart.removeAttribute("disabled");
      else cart.setAttribute("disabled", "");
    }
  }

  function resetOrderSummary() {
    $orderMsg().empty();
    $(".check_area li span").text("");
    $(".check_price").empty().attr("style", "visibility: hidden");
    setCheckoutUIEnabled(false);
    $("#units").val("");
    for (let i = 1; i <= 7; i++) {
      $("#choice" + i).val("");
    }
  }

  function loadPriceOnce() {
    if (Array.isArray(priceTable)) return $.Deferred().resolve(priceTable).promise();
    return $.ajax({ url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/nook_price.csv?v=1776135889", dataType: "text" }).then(function (text) {
      priceTable = $.csv.toArrays(text).map(function (row) {
        return row.map(function (v) {
          return parseInt(String(v).replace(/[^\d]/g, ""), 10);
        });
      });
      return priceTable;
    }).catch(function () {
      priceTable = [];
      return priceTable;
    });
  }

  function loadExistingOnce() {
    if (Array.isArray(existingList)) return $.Deferred().resolve(existingList).promise();
    return $.ajax({ url: "https://cdn.shopify.com/s/files/1/0549/1834/8887/files/nook_existing.csv?v=1776135890", dataType: "text" }).then(function (text) {
      existingList = $.csv.toArrays(text);
      return existingList;
    }).catch(function () {
      existingList = [];
      return existingList;
    });
  }

  function validateSizeForBlur() {
    const $msg = $sizeMsg();
    const errs = [];
    const h = readInt("haba");
    const d = readInt("depth");

    function pushErr(lim, val, isEmpty) {
      if (isEmpty || Number.isNaN(val)) {
        errs.push('<p class="note-size-error">' + lim.label + 'は' + lim.min + '〜' + lim.max + 'cmの範囲で入力してください（現在：未入力）</p>');
        return;
      }
      if (val < lim.min || val > lim.max) {
        errs.push('<p class="note-size-error">' + lim.label + 'は' + lim.min + '〜' + lim.max + 'cmの範囲で入力してください（現在：' + val + 'cm）</p>');
      }
    }

    pushErr(LIMITS.haba, h.val, h.isEmpty);
    pushErr(LIMITS.depth, d.val, d.isEmpty);

    if (errs.length) {
      $msg.html(errs.join(""));
      return false;
    }

    $msg.empty();
    return true;
  }

  function setBubble(sectionEl, html) {
    const $bubble = $(sectionEl).find(".material_bubble").first();
    if ($bubble.length) $bubble.html(html);
  }

  function hydrateFabricBubble() {
    const section = document.querySelector('input[name="colortype1"]') ? document.querySelector('input[name="colortype1"]').closest(".form.material") : null;
    const type = getFabricType();
    if (!section) return;
    setBubble(section, FABRIC_MATERIAL_TEXT[type] || "選択してください");
  }

  function hydrateColorBubble() {
    const input = document.querySelector('input[name="colortype2"]:checked');
    const type = (input && input.dataset && input.dataset.type ? input.dataset.type : "").toLowerCase();
    const section = document.querySelector('input[name="colortype2"]') ? document.querySelector('input[name="colortype2"]').closest(".form.material") : null;
    if (!section) return;
    setBubble(section, COLOR_DESC_TEXT[type] || "選択してください");
  }

  function getColorSplideRoot() {
    return document.querySelector('.splide[aria-label="カラーを選択"]') || document.querySelector("#splide03") || document.querySelectorAll(".splide")[1] || null;
  }

  function cacheColorSlidesOnce(colorRoot) {
    if (!colorRoot || colorOriginalSlides) return;
    const list = colorRoot.querySelector(".splide__list");
    if (!list) return;
    colorOriginalSlides = [];
    list.querySelectorAll(".splide__slide").forEach(function (slide) {
      colorOriginalSlides.push(slide.outerHTML);
    });
  }

  function rebuildColorSlidesByType(type, retryCount) {
    const colorRoot = getColorSplideRoot();
    const retries = retryCount || 0;
    if (!colorRoot) return;

    cacheColorSlidesOnce(colorRoot);

    const splide = (window.__splideMap && window.__splideMap.get(colorRoot)) || colorRoot.splide || null;
    if (!splide) {
      if (retries < 10) {
        setTimeout(function () {
          rebuildColorSlidesByType(type, retries + 1);
        }, 100);
      }
      return;
    }

    const targetType = String(type || "").toLowerCase();

    try {
      const len = typeof splide.length === "number" ? splide.length : ((splide.Components && splide.Components.Slides && splide.Components.Slides.getLength) ? splide.Components.Slides.getLength() : 0);
      for (let i = len - 1; i >= 0; i--) {
        splide.remove(i);
      }
    } catch (e) {
      try {
        for (let j = 0; j < 200; j++) {
          if ((splide.length || 0) <= 0) break;
          splide.remove(0);
        }
      } catch (e2) {}
    }

    const htmls = (colorOriginalSlides || []).filter(function (html) {
      const m = html.match(/name="colortype2"[^>]*data-type="([^"]+)"/i);
      const t = (m && m[1] ? m[1] : "").toLowerCase();
      return t === targetType;
    });

    const targets = htmls.length ? htmls : (colorOriginalSlides || []);
    targets.forEach(function (html) {
      try {
        splide.add(html);
      } catch (e) {}
    });

    try { splide.refresh(); } catch (e) {}
    try { splide.go(0); } catch (e) {}

    const list = colorRoot.querySelector(".splide__list");
    const first = list ? list.querySelector('input[name="colortype2"]:not(:disabled)') : null;
    if (first) {
      first.checked = true;
      first.dispatchEvent(new Event("change", { bubbles: true }));
    } else {
      hydrateColorBubble();
      updatePreviewImages();
    }
  }

  function updatePreviewImages() {
    const area1 = document.querySelector('img[name="area1"]');
    const area2 = document.querySelector('img[name="area2"]');
    const colorId = getColorId();
    const legTok = getLegColorToken();

    if (area1 && colorId) area1.src = BASE_IMG + colorId + ".png";
    if (area2) area2.src = BASE_IMG + "leg/" + legTok + ".png";
  }

  function resizeFormSizeImages() {
    const container = document.querySelector(".form_size--img");
    if (!container) return;

    const width = container.offsetWidth || 0;
    const imgs = container.querySelectorAll("img");
    imgs.forEach(function (img) {
      img.style.width = width + "px";
    });

    let maxH = 0;
    imgs.forEach(function (img) {
      const h = img.offsetHeight || 0;
      if (h > maxH) maxH = h;
    });

    if (maxH > 0) container.style.height = maxH + "px";
  }

  function bindResizeAfterLoad() {
    const container = document.querySelector(".form_size--img");
    if (!container) return;
    container.querySelectorAll("img").forEach(function (img) {
      img.addEventListener("load", resizeFormSizeImages, { passive: true });
    });
  }

  function findExistingCode(params) {
    if (!Array.isArray(existingList) || existingList.length === 0) return null;

    const w = params.w;
    const d = params.d;
    const h = params.h;
    const fabricType = String(params.fabricType || "").toLowerCase();
    const legH = params.legH;

    for (let i = 0; i < existingList.length; i++) {
      const row = existingList[i];
      if (!row || row.length < 6) continue;

      const code = String(row[0] == null ? "" : row[0]).trim();
      const rW = parseInt(String(row[1] == null ? "" : row[1]).replace(/[^\d]/g, ""), 10);
      const rD = parseInt(String(row[2] == null ? "" : row[2]).replace(/[^\d]/g, ""), 10);
      const rH = parseInt(String(row[3] == null ? "" : row[3]).replace(/[^\d]/g, ""), 10);
      const rFabric = String(row[4] == null ? "" : row[4]).trim().toLowerCase();
      const rLeg = parseInt(String(row[5] == null ? "" : row[5]).replace(/[^\d]/g, ""), 10);

      if (!code) continue;
      if (rW === w && rD === d && rH === h && rFabric === fabricType && rLeg === legH) {
        return code;
      }
    }

    return null;
  }

  function setChoiceValues(params) {
    const price = params.price;
    const haba = params.haba;
    const depth = params.depth;
    const seatDepth = 25;
    const fabricName = getFabricName();
    const colorName = getColorName();
    const legVal = getLegValue();

    const choice1 = "幅：" + haba + "cm/";
    const choice2 = "奥行：" + depth + "cm/";
    const choice3 = "高さ(座面)：" + seatDepth + "cm/";
    const choice4 = "生地：" + fabricName + "/";
    const choice5 = "カラー：" + colorName + "/";
    const choice6 = "脚：" + legVal + "/";
    const choice7 = "見積もり金額：" + price;

    $("#shop_bid").val(SHOP_BID);
    $("#variant_id").val(VARIANT_ID);
    $("#choice1").val(choice1);
    $("#choice2").val(choice2);
    $("#choice3").val(choice3);
    $("#choice4").val(choice4);
    $("#choice5").val(choice5);
    $("#choice6").val(choice6);
    $("#choice7").val(choice7);
    $("#units").val(String(Math.round(price / 100)));
  }

  function buildEncodedChoice() {
    const lines = [];
    for (let i = 1; i <= 7; i++) {
      const v = $("#choice" + i).val();
      if (String(v || "").length > 0) lines.push(v);
    }
    const choice = lines.join("\r\n");
    const unicodeArray = Encoding.stringToCode(choice);
    const eucArray = Encoding.convert(unicodeArray, { to: "EUCJP", from: "UNICODE" });
    return Encoding.urlEncode(eucArray);
  }

  function submitToRakutenCart(e) {
    if (e && typeof e.preventDefault === "function") e.preventDefault();

    const units = $("#units").val();
    const c1 = $("#choice1").val();
    const c7 = $("#choice7").val();
    if (!units || !c1 || !c7) return false;

    const encodedChoice = buildEncodedChoice();
    const existingForm = document.querySelector("form[name='cart_form_ori']");
    if (existingForm) existingForm.remove();

    const form = document.createElement("form");
    form.method = "post";
    form.name = "cart_form_ori";
    form.action = "https://basket.step.rakuten.co.jp/rms/mall/bs/cartadd/set";
    form.acceptCharset = "EUC-JP";
    form.target = "_blank";

    [
      { name: "shop_bid", value: SHOP_BID },
      { name: "item_id", value: ITEM_ID },
      { name: "variant_id", value: VARIANT_ID },
      { name: "units", value: units },
      { name: "choice", value: encodedChoice }
    ].forEach(function (d) {
      const input = document.createElement("input");
      input.type = "hidden";
      input.name = d.name;
      input.value = d.value;
      form.appendChild(input);
    });

    document.body.appendChild(form);
    form.submit();
    return false;
  }

  window.jump = function () {
    const $msg = $orderMsg();
    const errors = [];
    const h = readInt("haba");
    const d = readInt("depth");
    const seatDepth = 25;
    const fabricType = getFabricType();
    const band = getBandByFabric(fabricType);
    const color = document.querySelector('input[name="colortype2"]:checked');
    const leg = document.querySelector('input[name="option"]:checked');
    const legH = getLegHeight();

    $msg.empty();

    function requireInRange(r, lim) {
      if (r.isEmpty) {
        errors.push(lim.label + "を入力してください");
        return;
      }
      if (Number.isNaN(r.val)) {
        errors.push(lim.label + "は数値(半角)で入力してください");
        return;
      }
      if (r.val < lim.min || r.val > lim.max) {
        errors.push(lim.label + "は " + lim.min + "～" + lim.max + "cm の範囲で入力してください（現在: " + r.val + "cm）");
      }
    }

    requireInRange(h, LIMITS.haba);
    requireInRange(d, LIMITS.depth);

    if (!band) errors.push("生地を選択してください");
    if (!color) errors.push("カラーを選択してください");
    if (!leg) errors.push("脚を選択してください");

    if (errors.length) {
      errors.forEach(function (t) {
        $msg.append($("<p>").addClass("note-submit-error").text(t));
      });
      setCheckoutUIEnabled(false);
      $("#units").val("");
      return false;
    }

    const existingCode = findExistingCode({
      w: h.val,
      d: d.val,
      h: seatDepth,
      fabricType: fabricType,
      legH: legH
    });

    if (existingCode) {
      $msg.append(
        '<p class="existing-link">' +
          '<a href="' + EXISTING_URL + existingCode + '" target="_blank">' +
            '→既製品ページがございます。こちらのページよりお買い求めください。' +
          '</a>' +
        '</p>'
      );
      $(".check_price").empty().attr("style", "visibility: hidden");
      setCheckoutUIEnabled(false);
      $("#units").val("");
      return false;
    }

    const w10 = ceil10(h.val);
    const d10 = ceil10(d.val);
    const wIndex = Math.round((w10 - 60) / 10);
    const dIndex = Math.round((d10 - 40) / 10);
    const rowBase = ROW_BASE[band];

    if (!Array.isArray(priceTable) || !priceTable.length || rowBase == null) {
      $msg.append($("<p>").addClass("note-submit-error").text("価格表の読み込みに失敗しました"));
      setCheckoutUIEnabled(false);
      $("#units").val("");
      return false;
    }

    const raw = priceTable[rowBase + dIndex] && priceTable[rowBase + dIndex][wIndex];
    if (!Number.isFinite(raw)) {
      $msg.append($("<p>").addClass("note-submit-error").text("価格が見つかりませんでした"));
      setCheckoutUIEnabled(false);
      $("#units").val("");
      return false;
    }

    let price = raw + 0;

    // 20cmのみ加算（10cm・15cmは加算しない）
    if (legH === 20) {
      price += 3000;
    }

    const spans = document.querySelectorAll(".check_area ul li span");
    if (spans.length >= 5) {
      spans[0].textContent = String(h.val);
      spans[1].textContent = String(d.val);
      spans[2].textContent = getFabricName();
      spans[3].textContent = getColorName();
      spans[4].textContent = getLegValue();
    }

    setChoiceValues({ price: price, haba: h.val, depth: d.val });
    $(".check_price").text(formatYen(price)).attr("style", "");
    $msg.append('<p class="note-submit-ok">以下の内容を確認し、買い物かごにお進みください。</p>');
    setCheckoutUIEnabled(true);
    return false;
  };

  if (typeof window.checkBtn !== "function") {
    window.checkBtn = function () {
      updatePreviewImages();
      return true;
    };
  }

  $(function () {
    loadPriceOnce();
    loadExistingOnce();

    $("#shop_bid").val(SHOP_BID);
    $("#variant_id").val(VARIANT_ID);
    $("#seat_depth").val("25");

    resetOrderSummary();
    resizeFormSizeImages();
    bindResizeAfterLoad();
    $(window).on("resize", resizeFormSizeImages);

    hydrateFabricBubble();
    rebuildColorSlidesByType(getFabricType());
    updatePreviewImages();

    $(document).on("input", "#haba, #depth", function () {
      const cleaned = onlyDigits(this.value);
      if (this.value !== cleaned) this.value = cleaned;
    });

    $(document).on("blur", "#haba, #depth", function () {
      validateSizeForBlur();
    });

    $(document).on("change", 'input[name="colortype1"]', function () {
      if (!this.checked) return;
      const type = String((this.dataset && this.dataset.type) || "").toLowerCase();
      const section = this.closest(".form.material");
      setBubble(section, FABRIC_MATERIAL_TEXT[type] || "選択してください");
      rebuildColorSlidesByType(type);
      updatePreviewImages();
    });

    $(document).on("change", 'input[name="colortype2"]', function () {
      if (!this.checked) return;
      const type = String((this.dataset && this.dataset.type) || "").toLowerCase();
      const section = this.closest(".form.material");
      setBubble(section, COLOR_DESC_TEXT[type] || "選択してください");
      updatePreviewImages();
    });

    $(document).on("change", 'input[name="option"]', function () {
      updatePreviewImages();
    });

    const $frm = $('form[name="frm_detail"]');
    $frm.on("change input", "input, select, textarea", function () {
      const $t = $(this);
      if ($t.is("#units, #choice1, #choice2, #choice3, #choice4, #choice5, #choice6, #choice7")) return;
      resetOrderSummary();
    });

    $(document).on("click", "#modal-cart", function (e) {
      submitToRakutenCart(e);
    });

    $(document).on("click", ".btn-cart, .cartadd", function (e) {
      submitToRakutenCart(e);
    });

    $(document).on("submit", 'form[name="frm_detail"]', function (e) {
      submitToRakutenCart(e);
    });

    $(document).on("submit", "form[name='frm']", function (e) {
      submitToRakutenCart(e);
    });
  });
})(jQuery);
